// § 3.5 Tier 6 Step 63 / 69 — RFI detail page interactions:
//   - Submit "Add response" form via fetch + reload (avoids the
//     full-page POST round-trip and keeps focus on the thread).
//   - "Send to ACC" / "Retry sync" → POSTs the manual sync trigger
//     and shows a toast; the user reloads to see the new badge.
//   - Conflict resolution: Keep ConsLog / Keep ACC / Merge buttons
//     POST to the resolve endpoint and reload.
//
// Mirrors the slide-over ACC sync UX from `action_items_controller.js`.
// Manual-registered in `app/javascript/controllers/index.js`.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["responseForm"]

  async submitResponse(event) {
    event.preventDefault()
    const form = event.target
    const textarea = form.querySelector("textarea[name='rfi_response[body]']")
    const body = (textarea?.value || "").trim()
    if (!body) return

    const url = form.getAttribute("action")
    try {
      const resp = await fetch(url, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
        },
        body: new URLSearchParams({ "rfi_response[body]": body }).toString(),
        credentials: "same-origin"
      })
      if (!resp.ok) {
        this._toast("Could not post response", "error")
        return
      }
      this._toast("Response posted", "success")
      window.location.reload()
    } catch (e) {
      this._toast("Could not post response", "error")
    }
  }

  async sendToAcc(event) {
    const url = event.currentTarget.dataset.rfiDetailSyncUrlValue
    if (!url) return
    event.currentTarget.disabled = true
    try {
      const resp = await fetch(url, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
        },
        credentials: "same-origin"
      })
      const json = await resp.json()
      if (resp.ok) {
        this._toast("Sync to ACC enqueued — refresh in ~30 s.", "success")
      } else {
        this._toast(json.error || "Could not enqueue sync.", "error")
      }
    } catch (e) {
      this._toast("Could not enqueue sync.", "error")
    } finally {
      event.currentTarget.disabled = false
    }
  }

  async resolveConflict(event) {
    const winner = event.currentTarget.dataset.winner
    const url = event.currentTarget.dataset.rfiDetailResolveUrlValue
    if (!winner || !url) return
    try {
      const resp = await fetch(url, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
        },
        body: new URLSearchParams({ winner }).toString(),
        credentials: "same-origin"
      })
      if (resp.ok) {
        this._toast(`Conflict resolved (${winner}).`, "success")
        window.location.reload()
      } else {
        this._toast("Could not resolve conflict.", "error")
      }
    } catch (e) {
      this._toast("Could not resolve conflict.", "error")
    }
  }

  _toast(message, type) {
    const el = document.createElement("div")
    el.className = type === "error" ? "flash-toast-alert" : "flash-toast-notice"
    el.setAttribute("data-controller", "flash")
    el.setAttribute("data-flash-dismiss-after-value", "5000")
    el.textContent = message
    document.body.prepend(el)
  }
}
